import React from "react";
import "./styles.scss";
import PageHeader from "./header/PageHeader";
import SubSectionCard from "./subsection-card/SubsectionCard";
import { useWorkShop } from "../../../../contexts/workshop-context/WorkshopContext";

const Summary = () => {
  const workshop = useWorkShop();

  return (
    <div className="student-workshop-summary-wrapper">
      <PageHeader />
      <div className="workshop-summary-content">
        {workshop.workshopSections.map((sub, index) => (
          <SubSectionCard
            key={index}
            title={`${index + 1}. ${sub.subSectionTitle}`}
            onClick={() => workshop.setSelectedSubSection(sub)}
          />
        ))}
      </div>
    </div>
  );
};

export default Summary;
